import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../services/user.service";
import { NgForm } from "@angular/forms";

@Component({
  selector: "app-add-user-modal",
  templateUrl: "./add-user-modal.component.html",
  styleUrls: ["./add-user-modal.component.scss"],
})
export class AddUserModalComponent {
  @Output() closeSuccess = new EventEmitter<void>();
  @ViewChild("userForm") userForm!: NgForm;

  USER_ROLE_MAPPING: Record<string, string> = {
    HospitalAdmin: "Hospital Administrator",
    Coordinator: "Coordinator",
    Provider: "Provider",
  };

  loading = false;
  successMessage: string | null = null;
  errorMessage: string | null = null;
  showPassword = false; // Control visibility of password field

  user = {
    userType: "",
    email: "",
    tempPassword: "",
    phone: "",
    firstName: "",
    lastName: "",
  };

  userRoles: string[] = ["HospitalAdmin", "Coordinator", "Provider"];

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService
  ) {}

  selectUserType(role: string) {
    this.user.userType = role;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  copyTempPassword() {
    if (!this.user.tempPassword) return; // Ensure there's a password to copy

    // Create a temporary textarea element
    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = this.user.tempPassword;
    document.body.appendChild(tempTextArea);

    // Select and copy the text
    tempTextArea.select();
    document.execCommand("copy");

    // Remove the temporary element
    document.body.removeChild(tempTextArea);

    // Show copied feedback
    this.successMessage = "Temporary password copied to clipboard!";
    
  }

  closeModal() {
    this.activeModal.close(null);
  }

  submitUser() {
    this.loading = true;
    this.successMessage = null;
    this.errorMessage = null;

    this.userService.createUser(this.user).subscribe({
      next: (response) => {
        this.successMessage = "Copy the password to securely share it with the user.";
        this.closeSuccess.emit();
      },
      error: (error) => {
        console.error("User creation failed:", error.error);
        this.errorMessage =
          error.error?.details ??
          error.error?.error ??
          error.error?.message ??
          "User creation failed";
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
